import React, {useState, useEffect} from "react";
import EventManager from "./EventManager";

const useUpdateOn = (events, initialState) => {
  if (typeof events === 'string') events = [events];

  const [propValue, setProp] = useState(initialState);

  const callback = data => {
    setProp(data)
  };

  events.forEach(eventName => {
    EventManager.on(eventName, callback);
  });

  useEffect(() => () => {
    events.forEach(eventName => {
      EventManager.off(eventName, callback)
    });
  });

  return propValue

};

export default useUpdateOn;
